import React from "react";
import { Box, Button } from "@mui/material";
import {
  ArrowBack as ArrowBackIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
} from "@mui/icons-material";

interface EvacuationPlanHeaderProps {
  id: string | number;
  onBack: () => void;
  onEdit: () => void;
  onDelete: () => void;
  isDeleting?: boolean;
}

export const EvacuationPlanHeader: React.FC<EvacuationPlanHeaderProps> = ({
  id,
  onBack,
  onEdit,
  onDelete,
  isDeleting = false,
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        mb: 3,
      }}
    >
      <Button
        startIcon={<ArrowBackIcon />}
        onClick={onBack}
        variant="outlined"
      >
        Tillbaka
      </Button>
      <Box sx={{ display: "flex", gap: 2 }}>
        <Button
          startIcon={<EditIcon />}
          onClick={onEdit}
          variant="contained"
          disabled={isDeleting}
        >
          Redigera
        </Button>
        <Button
          startIcon={<DeleteIcon />}
          onClick={onDelete}
          variant="outlined"
          color="error"
          disabled={isDeleting}
        >
          {isDeleting ? "Tar bort..." : "Ta bort"}
        </Button>
      </Box>
    </Box>
  );
};
